import { useTranslation } from 'react-i18next'
import { getIsPool } from '@/utils/poolUtils'
import { ErrorPage } from '../ErrorPage'

export const NotFoundPage = () => {
  const { t } = useTranslation()
  const isPool = getIsPool()

  return (
    <ErrorPage
      description={t('notFoundPage.description', {
        context: isPool ? 'pool' : 'beach',
      })}
      title={t('notFoundPage.title')}
    />
  )
}
